import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Box, Button, Checkbox, LinearProgress } from "@material-ui/core";
import * as _ from 'lodash';

import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import { Link, useHistory } from "react-router-dom";

import AppTable from "../Table/AppTable";
import TablePaginationActions from "../Table/TablePaginationActions";
import AppUtil from "../../../../utilities/AppUtil";
import AppButton from "../../../../components/CustomButtons/AppButton";
import AppColor from "../../../../utilities/AppColor";
import InputSearch from "../../../../components/Input/InputSearch";
import { WORKER_TYPE } from "../../../../config/AppConfig";
import AppConfirmDialog from "../../../../components/Dialog/AppConfirmDialog";
import {
  fetchListRate,
  reduceDeleteRate
} from "store/slices/rate";
import {
  fetchSpecialties,
  fetchAccreditation
} from "store/slices/worker";
import { SHIFT, RATE_TYPE, DAY_TYPE, YEARS_OF_EXPERIENCE } from "config/AppConfig";
import AppSelect from "components/Select/AppSelect";


const headCells = [
  {
    id: "name",
    numeric: "left",
    disablePadding: false,
    label: "label.name",
    sort: true,
  },
  {
    id: "dayOfWeek",
    numeric: "left",
    disablePadding: false,
    label: "label.dayOfWeek",
    sort: true,
  },
  {
    id: "shift",
    numeric: "left",
    disablePadding: false,
    label: "label.shift",
    sort: true,
  },
  {
    id: "specialty",
    numeric: "left",
    disablePadding: false,
    label: "label.specialty",
    sort: true,
  },
  {
    id: "accreditation",
    numeric: "left",
    disablePadding: false,
    label: "label.accreditation",
    sort: true,
  },
  {
    id: "yearOfExperience",
    numeric: "left",
    disablePadding: false,
    label: "title.yearsOfExperience",
    sort: true,
  },
  {
    id: "rateType",
    numeric: "left",
    disablePadding: false,
    label: "label.rateType",
    sort: true,
  },
  {
    id: "actions",
    numeric: "center",
    disablePadding: false,
    label: "label.actions",
    sort: false,
  },
];

const WorkerTable = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const [queries, setQueries] = useState({
    sort: false,
    page_number: 1,
    page_size: 10,
    search_key: "",
    sort_field: "createdDate",
  });
  const [workerList, setWorkerList] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [specialties, setSpecialties] = useState([]);
  const [selected, setSelected] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [accreditations, setAccreditations] = useState([]);

  const [searchKey, setSearchKey] = useState("");

  const emptyRows = data.length === 0;

  const rateTypeOptions = RATE_TYPE.map(item => {
    return {
      value: item,
      label: t(`rateType.${item}`)
    }
  });
  const dateTypeOptions = DAY_TYPE.map(item => {
    return {
      value: item,
      label: t(`dayType.${item}`)
    }
  });
  const shiftOptions = SHIFT.map(item => {
    return {
      value: item,
      label: t(`shift.${item}`)
    }
  });
  const yearsOfExperienceOptions = YEARS_OF_EXPERIENCE.map(item => {
    return {
      value: item,
      label: item === 10 ? t('label.10OrLarge') : item
    }
  })

  const loadSpecialties = async () => {
    const result = await dispatch(fetchSpecialties());
    if (result.payload) {
      setSpecialties(result.payload);
    }
  };
  const loadAccreditations = async (workerType) => {
    const result = await dispatch(fetchAccreditation({ workerType: workerType }));
    if (result.payload) {
      setAccreditations(result.payload);
    }
  };
  const _handleDeleteClients = async () => {
    const params = {
      ids: selected
    }
    await dispatch(reduceDeleteRate(params));
    setShowDeleteModal(false);
    setSelected([]);
    if(data.length === 1 || selected.length === data.length) {
      _loadData({ ...queries, page_number: queries.page_number -1});
    } else {
      if (queries.search_key) {
        _loadData({ ...queries, search_key: queries.search_key });
    } else {
        _loadData();
    }
    }
  }
  const _handleSelect = (id) => {
    if (!selected.includes(id)) {
      setSelected([...selected, id]);
    } else {
      setSelected(selected.filter(item => item !== id))
    }
  }

  const _handleSelectAll = () => {
    if (data.length === countSelectInPage()) {
      setSelected([]);
    } else {
      setSelected(_.union(selected, data.map(item => item.id)));
    }
  }

  const handleChangePage = (event, newPage) => {
    _loadData({ ...queries, page_number: newPage + 1 });
    AppUtil.scrollToTopById("main-panel");
  };

  const handleChangeRowsPerPage = (event) => {
    _loadData({
      ...queries,
      page_number: 1,
      page_size: parseInt(event.target.value),
    });
    AppUtil.scrollToTopById("main-panel");
  };

  const onRequestSort = (event, property) => {
    _loadData({
      ...queries,
      sort_field: property,
      sort:
        property === queries.sort_field ? queries.sort !== true : true,
    });
  };

  const onSearch = (value) => {
    setSearchKey(value);
    _loadData({
      ...queries,
      search_key: value,
      page_number: 1,
    });
  };

  const _loadData = async ({
    page_number, page_size, search_key, sort, sort_field,
    rate_type, day_of_week, accreditation_id, shift_type, specialty_id, years_of_experience
  } = {}) => {
    const newQueries = {
      ...queries,
    };
    if (page_number) {
      newQueries.page_number = page_number;
    }
    if (page_size) {
      newQueries.page_size = page_size;
    }
    if (sort_field) {
      newQueries.sort_field = sort_field;
    }
    if (rate_type || rate_type === '') {
      newQueries.rate_type = rate_type;
    }
    if (day_of_week || day_of_week === '') {
      newQueries.day_of_week = day_of_week;
    }
    if (accreditation_id || accreditation_id === '') {
      newQueries.accreditation_id = accreditation_id;
    }
    if (shift_type || shift_type === '') {
      newQueries.shift_type = shift_type;
    }
    if (specialty_id || specialty_id === '') {
      newQueries.specialty_id = specialty_id;
    }
    if (years_of_experience || years_of_experience === '') {
      newQueries.years_of_experience = years_of_experience;
    }

    newQueries.search_key = search_key || "";
    newQueries.sort = !(!sort || false);
    setLoading(true);
    const result = await dispatch(fetchListRate({ ...newQueries, workerType: WORKER_TYPE.NURSE }));
    const { payload } = result;
    if (payload) {
      setWorkerList(payload.content);
      setTotalElements(payload.totalElements);
    }
    setQueries(newQueries);
    setLoading(false);
  };

  useEffect(() => {
    _loadData();
    loadSpecialties();
    loadAccreditations(WORKER_TYPE.NURSE);
  }, []);

  useEffect(() => {
    if (workerList)
      setData(workerList);
  }, [workerList]);

  const handleCreateWorker = (workerType) => {
    history.push(`/admin/rates/${workerType}/create`);
  };
  // eslint-disable-next-line react/prop-types
  const renderSelectField = ({ name, placeholder, options }) => (
    <AppSelect
      name={name}
      placeholder={t(placeholder)}
      options={options}
      className={"mr-2"}
      onChange={option => {
        const params = {};
        if (option) {
          params[name] = option.value;
          _loadData({ ...queries, ...params, page_number: 1 });
        } else {
          params[name] = '';
          _loadData({ ...queries, ...params , page_number: 1 });
        }
      }}
    />
  );

  const countSelectInPage = () => {
    const list = data.filter(item => {
      for (const i in selected) {
        if (item.id === selected[i]) {
          return true;
        }
      }
      return false;
    });
    return list.length;
  }

  return (
    <div id="check" style={{ height: emptyRows ? '70vh' : '' }}>
      <div>
        <AppButton
          label={t('button.create')}
          onClick={() => handleCreateWorker(WORKER_TYPE.NURSE)}
          style={{
            marginRight: '1rem'
          }}
        />
        <AppButton
          label={t('button.delete')}
          buttonColor={AppColor.pink}
          onClick={() => setShowDeleteModal(true)}
          disabled={selected.length === 0}
        />
      </div>
      <Box my={2}>
        <InputSearch
          onSearch={onSearch}
          searchText={searchKey}
        />
      </Box>
      <Box display="flex" flexWrap='wrap' my={2}>
        {
          renderSelectField({
            name: 'rate_type',
            placeholder: "label.rateType",
            options: rateTypeOptions
          })
        }
        {
          renderSelectField({
            name: 'day_of_week',
            placeholder: "label.dayOfWeek",
            options: dateTypeOptions
          })
        }
        {
          renderSelectField({
            name: 'shift_type',
            placeholder: "label.shift",
            options: shiftOptions
          })
        }
        {
          renderSelectField({
            name: 'specialty_id',
            placeholder: "label.specialty",
            options: specialties.map(item => {
              return {
                value: item.id,
                label: item.name
              }
            })
          })
        }
        {
          renderSelectField({
            name: 'accreditation_id',
            placeholder: "label.accreditation",
            options: accreditations.map(item => {
              return {
                value: item.id,
                label: item.name
              }
            })
          })
        }
        {
          renderSelectField({
            name: 'years_of_experience',
            placeholder: "title.yearsOfExperience",
            options: yearsOfExperienceOptions
          })
        }
      </Box>
      <AppTable
        onRequestSort={onRequestSort}
        order={queries.sort === true ? "asc" : "desc"}
        orderBy={queries.sort_field}
        rowCount={data.length}
        headCells={headCells}
        numSelected={countSelectInPage()}
        onSelectAllClick={_handleSelectAll}
      >
        <TableBody>
          {loading && (<TableRow>
            <TableCell colSpan={7} padding="none">
              <LinearProgress />
            </TableCell>
          </TableRow>)}
          {data.map((row, index) => (
            <TableRow key={index}>
              <TableCell padding="checkbox">
                <Checkbox
                  checked={selected.indexOf(row.id) !== -1}
                  inputProps={{ 'aria-labelledby': row.id }}
                  onClick={() => _handleSelect(row.id)}
                  color="primary"
                />
              </TableCell>
              <TableCell className="font-weight-bold">{row.name}</TableCell>
              <TableCell>
                {row.dayOfWeek && t(`dayType.${row.dayOfWeek}`)}
              </TableCell>
              <TableCell>
                {row.shiftType && t(`shift.${row.shiftType}`)}
              </TableCell>
              <TableCell>
                {specialties.find(item => item.id === row.specialtyId) ? specialties.find(item => item.id === row.specialtyId).name : ''}
              </TableCell>
              <TableCell>
                {accreditations.map(item => {
                  return {
                    value: item.id,
                    label: item.name
                  }
                }).find(item => item.value === row.accreditationId)
                  ? accreditations.map(item => {
                    return {
                      value: item.id,
                      label: item.name
                    }
                  }).find(item => item.value === row.accreditationId).label
                  : ''
                }
              </TableCell>
              <TableCell>
                {
                  row.yearsOfExperience === 10 ? t('label.10OrLarge') : row.yearsOfExperience
                }
              </TableCell>
              <TableCell>
                {row.rateType && t(`rateType.${row.rateType}`)}
              </TableCell>
              <TableCell>
                <Link
                  to={`/admin/rates/${WORKER_TYPE.NURSE}/${row.id}`}
                  className="text-center"
                >
                  <Button variant="text">
                    <i className="fas fa-edit" />
                  </Button>
                </Link>
              </TableCell>
            </TableRow>
          ))}

          {emptyRows > 0 && (
            <TableRow style={{ height: 53 }}>
              <TableCell colSpan={headCells.length} className="text-center">
                {t("label.no_data")}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              colSpan={headCells.length}
              count={totalElements}
              rowsPerPage={queries.page_size}
              page={queries.page_number - 1}
              SelectProps={{
                inputProps: { "aria-label": "rows per page" },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
              labelRowsPerPage={`${t("label.rows_per_page")}:`}
              labelDisplayedRows={({ from, to, count }) =>
                t("label.from_to", {
                  from,
                  to,
                  count:
                    count !== -1 ? count : `${t("text.more_than")} ${to}`,
                })
              }
            />
          </TableRow>
        </TableFooter>
      </AppTable>
      <AppConfirmDialog
        open={showDeleteModal}
        onConfirm={() => _handleDeleteClients()}
        onClose={() => setShowDeleteModal(false)}
        title={t('title.delete_rates')}
        content={t('text.delete_rates')}
      />
    </div>
  );
};

export default WorkerTable;
